import { ADD_DISABLED_ROUTE, REMOVE_DISABLED_ROUTE, RESET_DISABLED_ROUTES, SET_DISABLED_ROUTES } from "../reducers/disabledRoutes";


export function setDisabledRoutes(routes: string[], override: boolean = false) {
    return {
        type: SET_DISABLED_ROUTES,
        payload: { routes, override }
    };
}

export function addDisabledRoute(route: string) {
    return {
        type: ADD_DISABLED_ROUTE,
        payload: route
    };
}
export function removeDisabledRoute(route: string) {
    return {
        type: REMOVE_DISABLED_ROUTE,
        payload: route
    };
}

export function resetDisabledRoute(routes?: string[]) {
    return {
        type: RESET_DISABLED_ROUTES,
        payload: routes
    };
}